module.exports = __webpack_public_path__ + "644edb56df749a1dc543d41cfcecdfdf.jpg";